import React from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import Button, { ButtonProps } from '../../../Button';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import withCurrentGallection, {
  WithCurrentGallectionProps,
} from '../../_hocs/withCurrentGallection';

export type Props = {
  buttonView?: ButtonProps['view'];
  plusOnly?: boolean;
};

const enhance = compose(withCurrentGallection);

export const SubmitDeviationsButton: React.FC<
  Props & WithCurrentGallectionProps
> = ({ buttonView, plusOnly, currentFolderId }) => {
  const { t } = useTranslation();

  const submitURL = `${URLS.STUDIO}?new=1&folderid=${currentFolderId}`;

  return plusOnly ? (
    <Button view={'b3'} href={submitURL}>
      <AddIcon />
    </Button>
  ) : (
    <GhostButton variant="main" size="large" href={submitURL} icon={AddIcon}>
      {t('mediapopup.submitDeviations')}
    </GhostButton>
  );
};
SubmitDeviationsButton.displayName = 'SubmitDeviationsButton';

export default enhance(SubmitDeviationsButton) as React.ComponentType<Props>;
